import { BrainstormView } from './BrainstormView'
import { SessionPicker } from './SessionPicker'

/**
 * DevelopPage - Main build/develop screen.
 *
 * Simplified to a single view (BrainstormView) that handles the chat interface.
 * Session picker modal available for managing multiple sessions.
 */
export function DevelopPage() {
  return (
    <>
      <BrainstormView />
      <SessionPicker />
    </>
  )
}
